import styled, { css } from 'styled-components';
import { devices } from '@/constants/media';
import {
  MOBILE_PINNED_CONTENT_HEIGHT_PERCENT,
  PINNED_CONTENT_WIDTH_PERCENT,
  ROOM_BUTTONS_HEIGHT,
} from '@/constants/ui';

export const StyledRoom = styled.div`
  background-color: var(--color-background-dark);
  display: flex;
  flex-direction: column;
`;

export const RoomContent = styled.div<{
  $height: number;
}>`
  display: flex;
  overflow: hidden;
  min-height: 500px;
  ${({ $height }) => css`
    height: ${$height - ROOM_BUTTONS_HEIGHT}px;
  `}
  @media ${devices.sm} {
    flex-wrap: wrap;
  }
`;

export const GridContainer = styled.div<{
  $hasPinned?: boolean;
}>`
  ${({ $hasPinned }) => $hasPinned ? css`
    flex: 0 0 ${PINNED_CONTENT_WIDTH_PERCENT}%;
    min-width: ${PINNED_CONTENT_WIDTH_PERCENT}%;
    @media ${devices.sm} {
      flex: 0 0 100%;
      min-width: 100%;
      height: ${MOBILE_PINNED_CONTENT_HEIGHT_PERCENT}%;
    }
  ` : css`
    flex: 1;
  `}
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  position: relative;
`;
